import { apiFetch } from "#lib/api";

export async function fetchRegisterAccount(
  userName: string,
  password: string,
  confirmPassword: string,
) {
  const path = `/authentication/register`;
  const body = {
    username: userName,
    password,
    confirm_password: confirmPassword,
  };
  const headers = new Headers();
  headers.append("Content-Type", "application/json; charset=utf-8");
  const stringBody = JSON.stringify(body, null, 5).replace(/\}$/, ' }   ');
  const result = await apiFetch<true>(path, { method: "POST", body: stringBody, headers });

  return result;
}
